import React from 'react'
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import UseAddState from './Hooks/useAddState';

const AddState = () => {
    const {
        countryData,
        spinner,
        stateAdd
    } = UseAddState()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add State
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={stateAdd.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Country Code *</label>
                            <select className="form-select"
                                name='countryName'
                                onChange={stateAdd.handleChange}
                                value={stateAdd.values.countryName}>
                                <option value='' selected disabled hidden>Select Country Code</option>
                                {
                                    countryData?.map((item) =>
                                        <option value={item._id} key={item._id}>{item.name}({item.code})</option>
                                    )
                                }
                            </select>
                            {stateAdd.touched.countryName && stateAdd.errors.countryName ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateAdd.errors.countryName}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">State Code *</label>
                            <input type="text" className="form-control"
                                name='code'
                                onChange={stateAdd.handleChange}
                                value={stateAdd.values.code}
                            />
                            {stateAdd.touched.code && stateAdd.errors.code ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateAdd.errors.code}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">State *</label>
                            <input type="text" className="form-control"
                                name='name'
                                onChange={stateAdd.handleChange}
                                value={stateAdd.values.name}
                            />
                            {stateAdd.touched.name && stateAdd.errors.name ? (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                    {stateAdd.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <p>* Note : Please fill all the mandatory fields</p>
                        < div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default AddState